const setupGallery = (gallery) => {
  let currentIndex = 0

  const hiddenDivs = Array.from(
    gallery.querySelectorAll('.hidden.images > div')
  )

  const images = hiddenDivs.map((div) => div.getAttribute('data-image'))

  const titles = hiddenDivs.map((div) => div.getAttribute('data-title'))

  const preloadNextImage = () => {
    if (currentIndex > 0) {
      const preload = new Image()
      preload.src = images[currentIndex - 1]
    }

    if (currentIndex + 1 < images.length) {
      const preload = new Image()
      preload.src = images[currentIndex + 1]
    }
  }

  const currentImage = gallery.querySelector('.current-image')

  const currentTitle = gallery.querySelector('.gallery-title')

  const texts = gallery.querySelector('.texts')

  const prevButton = gallery.querySelector('.prev-button')
  const nextButton = gallery.querySelector('.next-button')

  const updateButtons = () => {
    prevButton.disabled = currentIndex === 0
    nextButton.disabled = currentIndex === images.length - 1

    if (prevButton.disabled) {
      prevButton.classList.add('opacity-25')
    } else {
      prevButton.classList.remove('opacity-25')
    }

    if (nextButton.disabled) {
      nextButton.classList.add('opacity-25')
    } else {
      nextButton.classList.remove('opacity-25')
    }
  }

  function updateImage() {
    currentImage.classList.remove('opacity-100')
    currentImage.classList.add('opacity-0')

    try {
      texts.classList.remove('opacity-100')
      texts.classList.add('opacity-0')
    } catch (e) {
      // no texts, all good
    }

    setTimeout(() => {
      currentImage.src = images[currentIndex]
      currentImage.classList.remove('opacity-0')
      currentImage.classList.add('opacity-100')

      try {
        currentTitle.innerHTML = titles[currentIndex]

        texts.classList.remove('opacity-0')
        texts.classList.add('opacity-100')
      } catch (e) {
        // no texts, all good
      }
    }, 300)

    updateButtons()
    preloadNextImage()
  }

  prevButton?.addEventListener('click', () => {
    currentIndex--
    updateImage()
  })

  nextButton?.addEventListener('click', () => {
    currentIndex++
    updateImage()
  })

  preloadNextImage()
  updateButtons()

  gallery.setAttribute('data-setup', 'true')
}

window.setupGallery = (name, config) => {
  const gallery = document.querySelector(`#gallery-${name}`, config)

  setupGallery(gallery)
}

window.setupGalleries = () => {
  const galleries = document.querySelectorAll(
    '.jcp-image-gallery:not([data-setup="true"])'
  )

  for (const gallery of galleries) {
    setupGallery(gallery)
  }
}
